const translations = {
    acres: 'Acres',
    applicationContext: 'Application Context',
    applicator: 'Applicator',
    crop: 'Crop',
    date: 'Date',
    field: 'Field',
    license: 'License',
    method: 'Method',
    readOnlyHintText: 'Driven by Application Details — read-only here.',
    state: 'State',
    targetPest: 'Target Pest',
    type: 'Type'
};

export default translations;
